<template>
  <div>
    <UserInfo
      :user="currentUser"
      :allowMethodCreation="true"
      :showEditLink="true"
    ></UserInfo>

    <CardsListUser
      :title="'Методы'"
      :userId="currentUser.id"
      :showFraza="false"
    ></CardsListUser>

    <CardsList
      :title="'Выбранные методы'"
      :cards="currentUser.favorite_cards"
    ></CardsList>
  </div>
</template>

<script>
import UserInfo from "@/components/UserInfo.vue";
import CardsListUser from "@/components/CardsListUser.vue";
import CardsList from "@/components/CardsList.vue";
import { mapGetters } from 'vuex';
import store from "@/store";

export default {
  components: {
    UserInfo, CardsList, CardsListUser
  },
  // data() {
  //   return {
  //   };
  // },
  computed: {
    ...mapGetters(['currentUser']),
  },
  beforeRouteEnter: async function (to, from, next) {
    console.log('Id component beforeRouteEnter');
    await store.dispatch('loadCurrentUser');
    next();
  }
};
</script>
